import getStore from '../store/store';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { getUnifiedInboxResolvedMailboxInfoOrSelf } from 'owa-session-store';

export function isGeneralPreferencesLoaded(mailboxInfo: MailboxInfo): boolean {
    // Handle UIB by considering the real mailboxInfo that will be used for copilot
    const effectiveMailboxInfo = getUnifiedInboxResolvedMailboxInfoOrSelf(mailboxInfo);

    const accountKey = getAccountKeyForMailboxInfo(effectiveMailboxInfo);
    return getStore().copilotGeneralPreferencesMap.has(accountKey);
}
